export default {
  index: 'crm-agreement-price-increase-list-view',
  store: 'crm-agreement-price-increase-create-view',
  edit: 'crm-agreement-price-increase-edit-view',
};
